import { FC } from 'react';

type Props = {
	className?: string;
};

const TickIcon: FC<Props> = ({ className }) => {
	return (
		<svg
			width='20'
			height='20'
			viewBox='0 0 20 20'
			xmlns='http://www.w3.org/2000/svg'
			fill='none'
			stroke='#2B2B2B'
			className={className}>
			<path
				d='M5 11.4545L7.5 14L15 6'
				stroke='inherit'
				strokeWidth='1.25'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
		</svg>
	);
};

export default TickIcon;
